import script from "./PairUpOver.vue?vue&type=script&setup=true&lang=js"
export * from "./PairUpOver.vue?vue&type=script&setup=true&lang=js"

import "./PairUpOver.vue?vue&type=style&index=0&id=ae42d87e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae42d87e"]])

export default __exports__